import { Vector2d } from "@stage/math";
import { Box } from "../Box";

/**
 * 左上角原点偏移
 */

/**
 * 变换支点
 * 左上角原点偏移
 */

/**
 * 重置大小
 */

/**
 * 缩放
 */
export var BoxTransforms;
(function (_BoxTransforms) {
  var defaultOrigin = {
    xOffset: 'left',
    yOffset: 'top'
  };
  function pivot(box) {
    var origin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultOrigin;
    var xOffset;
    var yOffset;
    switch (origin.xOffset) {
      case 'left':
        xOffset = 0;
        break;
      case 'center':
        xOffset = box.width / 2;
        break;
      case 'right':
        xOffset = box.width;
        break;
      default:
        xOffset = origin.xOffset;
        break;
    }
    switch (origin.yOffset) {
      case 'top':
        yOffset = 0;
        break;
      case 'center':
        yOffset = box.height / 2;
        break;
      case 'bottom':
        yOffset = box.height;
        break;
      default:
        yOffset = origin.yOffset;
        break;
    }
    console.log(xOffset, yOffset);
    return {
      xOffset: xOffset,
      yOffset: yOffset
    };
  }
  _BoxTransforms.pivot = pivot;
  function offsetOfTransform(box, transformOrigin, translate) {
    var pivot = Box.pivot(box);
    var transformPivot = BoxTransforms.pivot(box, transformOrigin);
    var origin = Vector2d.add({
      x: box.x,
      y: box.y
    }, {
      x: transformPivot.xOffset,
      y: transformPivot.yOffset
    });
    var newPivot = Vector2d.add(pivot, {
      x: translate.x,
      y: translate.y
    });
    var transformedOrigin = Vector2d.rotate(Vector2d.rotate(origin, box.rotate, pivot), -box.rotate, newPivot);
    return {
      x: transformedOrigin.x - origin.x,
      y: transformedOrigin.y - origin.y
    };
  }
  _BoxTransforms.offsetOfTransform = offsetOfTransform;
  function resize(box, transform) {
    var _transform$width = transform.width,
      width = _transform$width === void 0 ? 0 : _transform$width,
      _transform$height = transform.height,
      height = _transform$height === void 0 ? 0 : _transform$height,
      origin = transform.origin;
    var pivot = BoxTransforms.pivot(box, origin);
    var delta = {
      x: width - box.width,
      y: height - box.height
    };
    var translate = {
      x: -delta.x * (pivot.xOffset / box.width),
      y: -delta.y * (pivot.yOffset / box.height)
    };
    var originTranslate = {
      x: delta.x * (0.5 - pivot.xOffset / box.width),
      y: delta.y * (0.5 - pivot.yOffset / box.height)
    };
    var offset = offsetOfTransform(box, origin, Vector2d.rotate(originTranslate, box.rotate));
    return {
      x: box.x + translate.x + offset.x,
      y: box.y + translate.y + offset.y,
      width: width,
      height: height,
      rotate: box.rotate
    };
  }
  _BoxTransforms.resize = resize;
})(BoxTransforms || (BoxTransforms = {}));